<template>
  <table id="job-board-offer-list">
    <tbody>
      <tr class="border-none" role="row" v-for="(offer, index) in offers" :key="index">
        <td class="margin-none pad-none">
          <div class="offer-item margin-none valign-wrapper">
            <div class="offer-description">
              <a target="_blank" :href="offer.link">
                <h4 class="color-company color-company-on-white">{{ offer.name }}</h4>
              </a>
              <h5 v-if="showCompanyLogo && !offer.confidential" class="company-logo">
                <img :src="companies[offer.owner_company].logo" alt="" />
                {{ companies[offer.owner_company].name }}
              </h5>
              <ul>
                <li>{{ getLocationLabel(offer) }}</li>
                <li>{{ $tmap('hire_modes', offer.hire_mode, offer.lang) }}</li>
                <li>{{ $tmap('remote_work', offer.remote_work, offer.lang) }}</li>
                <li>{{ $tmap('contract_types', offer.contract_type, offer.lang) }}</li>
              </ul>
              <p>{{ $t("job_portal.publication_days", { publication_days: offer.publication_days }) }}</p>
            </div>
            <div class="offer-actions">
              <span v-if="getLastAccessOffer(offer)" class="color-company color-company-on-white">
                <i class="fa fa-bolt"></i>
                {{ getLastAccessOffer(offer) }}
              </span>
              <a target="_blank" :href="offer.link" class="btn background-color-company contrast-color-company">
                {{ $t("job_portal.apply") }}
              </a>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "JobBoardOfferList",
  components: {
  },
  props: {
    offers: {
      type: Array,
      default: []
    },
    companies: {
      type: Object,
      default: {}
    },
    showCompanyLogo: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    getLastAccessOffer(offer) {
      const lastAccessOffer = new Date(offer.last_access_offer);
      const diffDate = Date.now() - lastAccessOffer;
      const diffDateDays = Math.ceil(diffDate / (1000 * 60 * 60 * 24));
      let lastAccessOfferLabel = '';
      if (diffDateDays <= 1) {
        lastAccessOfferLabel = this.$i18n.t('aira_portal.offer_last_access_today');
      } else if (diffDateDays <= 7) {
        lastAccessOfferLabel = this.$i18n.t('aira_portal.offer_last_access_week');
      }
      return lastAccessOfferLabel;
    },
    getLocationLabel(offer) {
      let country_flag = this.$i18n.transFromMap('countries_flag', offer.country, offer.lang)
      if (offer.confidential) {
        let country_label = this.$i18n.transFromMap('countries', offer.country, offer.lang)
        return `${country_flag} ${country_label}`;
      } else {
        let region_label = this.$i18n.transFromMap('regions', offer.region, offer.lang)
        let city_label = this.$i18n.transFromMap('cities', offer.city, offer.lang)
        return `${country_flag} ${city_label}, ${region_label}`;
      }
    }
  },
};
</script>